import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ModalService } from '../../../../shared/services/modal.service';
import { PasswordChangeDialog } from '../password-change-dialog/password-change-dialog';
import { firstValueFrom } from 'rxjs';
import { ProfileService } from '../../services/profile.service';
import { PasswordChangedDTO } from '../../models/password-changed-dto';

@Component({
  selector: 'app-profile',
  imports: [DatePipe],
  templateUrl: './profile.html',
  styleUrl: './profile.scss',
})
export class Profile {

  readonly profileService = inject(ProfileService);
  readonly passKeys = this.profileService.resources.getPassKeys();
  readonly profile = this.profileService.resources.getProfile();

  readonly modal = inject(ModalService);

  async deletePassKey(credentiaId: string, event: MouseEvent) {
    event.preventDefault();
    if (! await this.modal.confirm('Eliminar credencial', 'Desea eliminar la credencial?')) {
      return;
    }

    await firstValueFrom(this.profileService.deletePassKey(credentiaId));
    this.passKeys.reload();
  }

  async passwordChange() {
    const dialog = this.modal.open(PasswordChangeDialog, {}, state => {
      state.showCurrentPassword.set(true);
      state.passwordChangedCallback = async (x: PasswordChangedDTO) => {
        await firstValueFrom(this.profileService.changePassword(x.currentPassword, x.password));
      };
    });


  }
}
